<template>
    <div class="hpProginfo">        
        <!--popup-->
        <div :class="['hpi-outer',isFrameActive ? 'active':'']">
            <div @click="closeInfo" class="closebtn"></div>

            <div :class="['hpi-inner',isActive ? 'active':'']">

                <div v-if="item_info.time!=''">
                    <div :class="['hpi-time','info_split']">{{item_info.time}}</div>
                </div>
                <div v-if="item_info.speaker">
                    <div :class="['hpi-speaker','info_split','fs16']">{{item_info.speaker}}</div>
                </div>
                <div v-if="item_info.title!=''">
                    <div :class="['hpi-lecture','info_split']">{{item_info.title}}</div>
                </div>
                <div>
                    <div :class="['hpi-sepline',getRndColor()]"></div>
                </div>

                <div :class="['hpi-cols',hasFeatures ? '':'single']" v-if="hasContent">
                    <div class="hpi-left">
                        <template v-for="(item,index) in item_info.content">
                            <div :key="index">
                                <div class="hpi-text info_split fs14">{{item}}</div>
                            </div>
                        </template>
                    </div>

                    <div class="hpi-right">
                        <!-- {{item_info.features}} -->
                        <template v-for="(featureItem,fIndex) in item_info.features">
                            <div :key="'feature_'+fIndex">
                                <div :class="['feature-title','hpi-text','info_split','fs14']">{{featureItem.title}}</div>
                                <!--                             
                                <div :class="['hpi-text','info_split']">{{featureItem}}</div>
                                -->
                                <ul class="features-list">
                                    <li v-for="(feat,fi) in featureItem.items" :key="'feat_'+fi">
                                        <div :class="['hpi-li-text']">{{feat}}</div>
                                    </li>
                                </ul>
                            </div>
                         </template>
                    </div>

                </div>

                <!--
                <template v-for="(item,index) in item_info">
                    <div :key="index">
                        <div v-if="index==0 || index==1" :class="[classByIndex(index),'info_split']">
                            {{item}}
                        </div>
                        <div v-else-if="index==2" :class="['hpi-sepline',getRndColor()]"></div>
                    </div>
                </template>
                -->
            </div>



        </div>
    </div>
</template>

<style>    
    .hpProginfo
    {
        position: fixed;top: 0px;left: 0px;
        background-color: transparent;
        width: 100vw;height: 100vh;
        z-index: 1500;
    }

    .hpProginfo .hpi-outer
    {
        width: 80vw;
        height: 90vh;
        min-width: 800px;
        min-height: 550px;
        background-color: #fff;
        position: relative;    
        top:50%;left: 50%;
        transform: translate(-50%,-50%);
        padding: 70px;
        display: grid;
        align-items: center;
        -webkit-box-shadow: 0px 0px 11px 4px rgba(94,94,94,0.36); 
        box-shadow: 0px 0px 11px 4px rgba(94,94,94,0.36);        
        opacity: 0;
        transition: all ease 0.3s;
    }
    .hpProginfo .hpi-outer.active
    {
        opacity: 1;
    }    


    .hpProginfo .hpi-outer .hpi-inner
    {
        text-align: left;
        width: 100%;
        position: relative;
        opacity: 0;
        max-height: 80vh;
        overflow-y: scroll;        
    }
    .hpProginfo .hpi-outer .hpi-inner.active
    {
        opacity: 1;
    }    
    .hpProginfo .hpi-outer .closebtn
    {
        position: absolute !important;
        top: 3vh;
        right:3vh;
    }

    /* Decor line */
    .hpi-sepline
    {
        transition:width 2s cubic-bezier(.28,0,0,.99);
        width: 0px;height: 18px;margin-top: 10px;
    }
    .hpProginfo .hpi-outer .hpi-inner.active .hpi-sepline
    {
        width: 120px;
    }
    .hpi-sepline.col1{border-top: solid 3px #652881;}    
    .hpi-sepline.col2{border-top: solid 3px #d41528;}    
    .hpi-sepline.col3{border-top: solid 3px #eb6b41;}    
    .hpi-sepline.col4{border-top: solid 3px #50baa6;}    
    .hpi-sepline.col5{border-top: solid 3px #37abdf;}    


    /* animate text */
    .hpProginfo .hpi-inner .info-split
    {
        clear: both;padding-bottom: 20px;
    }

    .hpi-time,
    .hpProginfo .hpi-inner .info-split.hpi-time div{
        font-size: 14px;
        display: none;
    }

    .hpi-speaker,
    .hpProginfo .hpi-inner .info-split.hpi-speaker div{
        /* font-size: 16px; */
        font-weight: 300 !important;
        padding-top: 8px;
    }

    /* LECTURE NAME */
    .hpi-lecture{padding-top: 8px;padding-bottom: 8px;}
    .hpi-lecture,
    .info-text.hpi-lecture-cls
    {
        letter-spacing: -1px !important;
        font-size: 24px;font-weight: 500 !important;line-height: 28px;        
    }

    /* TEXT */
    .hpi-text
    {
        padding-bottom: 16px !important;
        line-height: 20px;
    }
    .hpi-text.info_split{
        /* word-wrap: break-word;overflow-wrap: break-word; */
        padding-bottom: 20px !important
    }/* not working !!!!!*/ 

    .hpi-text,
    .hpi-text.hpi-text-cls
    {
/*         font-size: 16px;
        font-weight: 200 !important;
 */        line-height: normal; 
        font-weight: 300;
    }
    .hpi-li-text,
    .hpi-li-text.hpi-text-cls
    {
        font-size: 14px;
        font-weight: 300 !important;
        line-height: 20px; 
    }

    .hpProginfo .info-textline{overflow: hidden;}
    .hpSpeakerInfo .info-textline .info-text{opacity: 0;}

    .hpProginfo .info-textline .info-text{
        opacity: 0;
        animation-delay: calc(0.1s * var(--line_index)) !important;
        animation:info-text-up 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;      
        padding-bottom: 2px;  

    }
    @keyframes info-text-up {
        from {transform: translateY(40px);opacity: 0;}  
        to {transform: translateY(0);opacity: 1;}
    }    


    .hpi-cols
    {
        width: 100%;
        display: grid;
        grid-template-columns: 55% auto;
        gap: 40px;
    }
    .hpi-cols.single
    {
        grid-template-columns: 100% 0%;
        gap:0px;
    }
    .hpi-cols .hpi-left
    {
        width: 100%;
    }
    .hpi-cols .hpi-right
    {
        width: 100%;
    }
    .hpi-cols.single .hpi-right
    {
        display: none;
    }
    .hpi-cols .hpi-right .hpi-text.info_split {
        padding-bottom: 0px !important;
    }


    .feature-title
    {
        font-weight: 500 !important;
    }
    .features-list
    {
        padding-inline-start: 20px;
        margin-top: 5px;
        margin-bottom: 25px;
    }
    .features-list li
    {
        font-size: 11px;
    }




  @media (max-width: 850px) { 
    .hpProginfo
    {
        width: 100vw;height: 100vh;
        
    }    
    .hpProginfo .hpi-outer
    {        
        overflow-y: scroll;
        width: 100vw;
        height: 100vh;
        min-width: 100vw;
        min-height: 100vh;
        padding: 80px 55px;
        display: block;
    }    
    .hpi-cols
    {
        display: block;
        clear: both;
    }
    .hpProginfo .hpi-outer .hpi-inner
    {
        max-height:none;
        overflow-y: auto;        
    }    
  }    

  /* LARGE SCREENS */
  @media (min-width: 1600px) { 
    .hpProginfo .hpi-outer
    {        
        width: 85vw;
        height: 80vh;
        /* transform: translate(-50%,-50%) scale(1.3); */
        padding: 8vw;
    }    
    .hpi-li-text,
    .hpi-li-text.hpi-text-cls
    {
        font-size: clamp(14px, 1.2vw, 24px) !important;
        line-height: normal;
        padding-bottom: 2px;
    }
    .hpi-cols
    {
        gap: 5vw;
    }
    .info-text.hpi-lecture-cls
    {
        letter-spacing: -1px !important;
        font-size: 40px;        
        line-height: 42px;
    }
    .hpi-sepline
    {
        height: 30px;
        margin-top: 26px;        
    }
    .hpProginfo .hpi-outer .hpi-inner.active .hpi-sepline
    {
        width: 10vw;
    }

  }      

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
        .___info-text,
        .___info-text.info-text-cls{
            font-size: 16px !important;
            font-weight: 200 !important;
            line-height: 21px !important;  
        }
        .___hpi-lecture,
        .___info-text.hpi-lecture-cls
        {
            letter-spacing: -1px !important;
            font-size: 30px !important;
            font-weight: 500 !important;
            line-height: 35px !important;        
        }
    }

    /* Landscape iPad mini 1, iPad 1 and iPad 2 */
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: landscape)
    {

    }


</style>

<script>
import site_data from "@/site_data.json"
import { splitLines }         from "@/utils";

export default {
  data() {
    return {
        isFrameActive:false,
        isActive:false,
        prog:site_data[0].PROGRAM,
    }
    },
    props: ['item_info'],
    mounted()
    {
        var vm=this;
        this.initText();
        vm.isFrameActive=true;
        setTimeout(() => 
        {        
            vm.isActive=true;
        }, 500);        
    },
    computed:
    {
        hasFeatures()
        {
            if(this.item_info.features && this.item_info.features.length>0)
            {
                return true;
            }
            return false;
        },
        hasContent()
        {
            if(this.item_info.content && this.item_info.content.length>0)
            {
                return true;
            }
            return false;
        }
    },
    methods:
    {
        initText()
        {      
            var hpProginfo = document.getElementsByClassName('hpProginfo')[0];
            var splitBlocks = hpProginfo.getElementsByClassName('info_split');
            for (var i = 0; i < splitBlocks.length; i++)
            {
                let firstClass = splitBlocks[i].classList[0];
                let innerClass = 'info-text '+firstClass+"-cls";
                let delayMultiply =1;// (i+1)*0.3;
                splitLines(delayMultiply,splitBlocks[i],'info-textline',innerClass); 
            }
        },
        getRndColor()
        {
            return "col"+this.randomInteger(1,5);
        },
        randomInteger(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        classByIndex(index)
        {
            let className = "hpi-text";
            if(index==0){
                className="hpi-time";
            }else if(index==1){
                className="hpi-speaker";
            }else if(index==2){
                className="hpi-lecture";
            }
            return className;
        },
        closeInfo()
        {
            this.$emit("close-proginfo");  
        }
    }
};
</script>

